import { siteMeta } from "./siteMeta.js";

// Purchase destinations live in siteMeta; keep each seller bound to its edition here.
export const bookEditions = [
  {
    slug: "the-universe-without-noise",
    number: "One",
    title: "The Universe Without Noise",
    status: "Available now",
    editions: [
      { title: "Kindle", description: "Buy the ebook, or read with a Kindle Unlimited subscription. Available on Kindle and in the Kindle app; check Amazon for current availability.", links: [{ retailer: "Amazon", format: "Kindle", url: siteMeta.bookOneKindleUrl, affiliate: true }] },
      { title: "Paperback", description: "The story in a softcover edition.", links: [{ retailer: "IngramSpark", format: "Paperback", url: siteMeta.bookOneDirectPaperbackUrl }, { retailer: "Amazon", format: "Paperback", url: siteMeta.bookOnePaperbackUrl, affiliate: true }] },
      { title: "Hardback", description: "The standard hardback edition.", links: [{ retailer: "Amazon", format: "Hardback", url: siteMeta.bookOneHardbackUrl, affiliate: true }] },
      { title: "Special-edition hardback", description: "Cloth-bound with a full dust jacket.", links: [{ retailer: "IngramSpark", format: "Hardback", edition: "Special edition", url: siteMeta.bookOneSpecialEditionHardbackUrl }] },
    ],
  },
  {
    slug: "the-paradox-beyond-silence",
    number: "Two",
    title: "The Paradox Beyond Silence",
    status: "Available now",
    editions: [
      { title: "Kindle", description: "The digital edition for Kindle and the Kindle app.", links: [{ retailer: "Amazon", format: "Kindle", url: siteMeta.bookTwoKindleUrl, affiliate: true }] },
      { title: "Paperback", description: "The story in a softcover edition.", links: [{ retailer: "IngramSpark", format: "Paperback", url: siteMeta.bookTwoDirectPaperbackUrl }, { retailer: "Amazon", format: "Paperback", url: siteMeta.bookTwoPaperbackUrl, affiliate: true }] },
      { title: "Hardback", description: "The standard hardback edition.", links: [{ retailer: "Amazon", format: "Hardback", url: siteMeta.bookTwoHardbackUrl, affiliate: true }] },
      { title: "Special-edition hardback", description: "Cloth-bound with a full dust jacket.", links: [{ retailer: "IngramSpark", format: "Hardback", edition: "Special edition", url: siteMeta.bookTwoSpecialEditionHardbackUrl }] },
    ],
  },
  {
    slug: "the-forever-inside-nothing",
    number: "Three",
    title: "The Forever Inside Nothing",
    status: "In development",
    note: "The final novel in The Optimiser Trilogy. Publication date and purchase links will be announced when available.",
    editions: [
      { title: "Kindle", description: "The digital edition for Kindle and the Kindle app.", status: "Coming soon", links: [] },
      { title: "Paperback", description: "The story in a softcover edition.", status: "Coming soon", links: [] },
      { title: "Hardback", description: "The standard hardback edition.", status: "Coming soon", links: [] },
      { title: "Special-edition hardback", description: "Cloth-bound with a full dust jacket.", status: "Coming soon", links: [] },
    ],
  },
];

export const purchaseUrls = new Set(bookEditions.flatMap((book) => book.editions.flatMap((edition) => edition.links.map((link) => link.url))));
